import { cn } from '@/lib/utils';

/**
 * Labelled stack of one or more form controls. Drop-in replacement for
 * `@nearst/ui`'s `InputGroup` — same `{ label, htmlFor, requiredField }` API
 * — but rendered with Unify design tokens and the system-ui font stack.
 */
export function InputGroup({ className, label, htmlFor, children, requiredField = false }) {
	return (
		<div className={cn('flex flex-col gap-1.5', className)}>
			{label ? (
				<label htmlFor={htmlFor} className="text-sm font-medium text-foreground">
					{label} {requiredField ? <span className="text-destructive">*</span> : null}
				</label>
			) : null}
			<div className="flex flex-col gap-2">{children}</div>
		</div>
	);
}
